<template>
  <vue-recaptcha
    v-if="recaptchaLoaded"
    ref="recaptcha"
    class="g-recaptcha"
    :sitekey="publicKey"
    :size="size"
    @verify="onCaptchaVerified"
    @expired="onCaptchaExpired"
  />
</template>
<script>

import VueRecaptcha from 'vue-recaptcha';
import loadScript from '../../helpers/script-loader';

if (document.querySelector('.g-recaptcha')) {
  loadScript('https://www.google.com/recaptcha/api.js?onload=vueRecaptchaApiLoaded&render=explicit');
}

export default {
  name: 'Recaptcha',
  components: {
    VueRecaptcha,
  },
  props: {
    publicKey: String,
  },
  data() {
    return {
      sizeRecaptcha: 'optional',
      recaptchaLoaded: false,
    };
  },
  computed: {
    isDev() {
      return window.location.host.includes('nsite-') || window.location.host.includes('boxberry.docker');
    },
    size() {
      return window.innerWidth < 370 ? 'compact' : 'normal';
    },
  },
  beforeMount() {
    if (window.vueRecaptchaApiLoaded !== true) {
      window.vueRecaptchaApiLoaded = () => {
        this.recaptchaLoaded = true;
        window.vueRecaptchaApiLoaded = true;
      };
      loadScript('https://www.google.com/recaptcha/api.js?onload=vueRecaptchaApiLoaded&render=explicit');
    } else {
      this.recaptchaLoaded = true;
    }
  },
  mounted() {
    if (this.isDev) {
      this.onCaptchaVerified('123');
    }
  },
  methods: {
    onCaptchaVerified(token) {
      this.$emit('verified', token);
    },
    onCaptchaExpired() {
      if (this.isDev) return;
      this.$emit('expired');
      this.reset();
    },
    reset() {
      if (this.isDev) return;
      this.$refs.recaptcha.reset();
    },
  },
};
</script>
